<template>
    <div>

        <h2 class="mt-0 mb-2" v-text="`${$props.commonObject.object_name} - Items`" />

        <div id="ag-grid-common-object-items-container">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                :gridOptions="gridOptions"
                @row-double-clicked="(params) => editItem(params.data)"
                :groupHeaders="true"
                :rowHeight="40">
            </ag-grid-vue>
        </div>
        <v-btn color="#c42111" class="mt-3 mr-3" @click="newItem" :disabled="$props.lockSave" v-if="showGrid">New</v-btn>
        <v-btn color="#c42111" class="mt-3 mr-3" @click="$emit('back')" v-if="showGrid">Back</v-btn>

        <v-dialog v-model="showItemEdit" max-width="80%" width="800px" persistent @keydown="(k) => {k.key == 'Escape' ? showItemEdit = false : null}">
            <item-edit :itemFields="itemFields" :itemClone="selectedItemClone" :fromSiteBook="false" v-if="showItemEdit" @save="saveItems" @cancel="onItemEditCancel"></item-edit>
        </v-dialog>
    
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import ItemEdit from "@/components/CommonObjects/ItemEdit";
export default {
  name: 'ItemsList',
  props: ['commonObject', 'lockSave'],
  components: {
      'ag-grid-vue': AgGridVue,
      ItemEdit
  },
  data: () => ({
    showGrid: false,
    selectedItemClone: null,
    itemFields: [],
    showItemEdit: false,
    itemsList: []
  }),

  computed: {
    
  },

  methods: {
    getCommonObjectItems: function() {
        this.showGrid = false;
        let route = (TELSA.apiHost + "commonobjects/itemslist");
        TELSA.loading(true);
        return this.$http.post(route, {args: {commonObjectId: this.$props.commonObject.object_id}}).then(response => {
            let result = response.body;
            this.itemsList = result.common_object_items;
            this.buildAgGrid();
            TELSA.loading(false);
        });
    },

    buildAgGrid: function() {
        this.showGrid = false;
        this.gridOptions = {};
        this.gridOptions.rowData = this.itemsList;
        this.gridOptions.columnDefs = this.createColumnDefs();
        let self = this;
        this.gridOptions.onGridReady = function(params) {
            self.gridOptions.api.hideOverlay();
            //self.gridOptions.columnApi.autoSizeColumns();
            self.gridOptions.api.sizeColumnsToFit();
        }

        this.gridOptions.getContextMenuItems = function() {
            return [
                'copy',
                'copyWithHeaders',
                'paste',
                'csvExport',
                'excelExport'
            ];
        };

        this.gridOptions.defaultColDef = {
            sortable: true,
            filter: true,
            resizable: true
        }
        this.showGrid = true;
    },

    createColumnDefs: function() {
        let columnDefs = [];
        const self = this;
        columnDefs = [
            { 
                headerName: '', 
                suppressSizeToFit: true,
                width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                cellRenderer: class {
                    init(params) {
                        this.params = params;
                        this.eGui = document.createElement('div');
                        this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle item-list-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                            <span class="mdi mdi-delete-circle item-list-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                        
                        this.editButtonHandler = this.editButtonHandler.bind(this);
                        this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                        this.editButton = this.eGui.querySelectorAll('.item-list-action')[0];
                        this.deleteButton = this.eGui.querySelectorAll('.item-list-action')[1];
                        this.editButton.addEventListener('click', this.editButtonHandler);
                        this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                    }
                    getGui() {
                        return this.eGui;
                    }
                    editButtonHandler(event) {
                        event.stopPropagation();
                        this.params.editFunction(this.params);
                    }
                    deleteButtonHandler(event) {
                        event.stopPropagation();
                        this.params.deleteFunction(this.params);
                    }
                    destroy() {
                        this.editButton.removeEventListener('click', this.editButtonHandler);
                        this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                    }
                },
                cellRendererParams: {
                    editFunction: (params) => {
                        console.log('edit CO ITEMMM');
                        if(!self.lockSave) {
                            this.editItem(params.data);
                        }
                    },
                    deleteFunction: (params) => {
                        console.log('NUKE CO ITEMMM');
                        if(!self.lockSave) {
                            this.deleteItemClick(params.data);
                        }
                    }
                }
            },
            { 
                headerName: 'Item Name', 
                field: 'item_name', 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
        ];
        return columnDefs;
    },

    editItem: function(item) {
        if(this.lockSave) {
            return;
        }
        TELSA.loading(true);
        this.itemFields = [];
        let route = (TELSA.apiHost + "commonobjects/itemsitem");
        this.$http.post(route, {args: {commonObjectId: this.$props.commonObject.object_id, itemId: item.item_id}}).then(response => {
            let selectedItemValues = response.body;
            // Some fancy stuff here to handle matching up fields and items.
            let fields = this.$props.commonObject.object_fields;
            let add = true;
            for(let field of fields) {
                add = true;
                for(let selectedItemValue of selectedItemValues) {
                    if(field.field_id == selectedItemValue.object_field.field_id) {
                        this.itemFields.push(selectedItemValue);
                        add = false;
                        break;
                    }
                }
                if(add) {
                    this.itemFields.push({
                        item_id: item.item_id,
                        item_value: '',
                        object_field: field
                    });
                }
            }
            this.selectedItemClone = JSON.parse(JSON.stringify(item));
            this.showItemEdit = true;
            TELSA.loading(false);
        });
    },

    deleteItemClick: function(item) {
        this.$store.commit('showConfirmModal', {
            title: 'Delete Item',
            message: `This operation will delete this item, and remove this object from all sites. Are you sure you want to do this?`,
            type: 'delete',
            hideCancel: false,
            confirmAction: () => this.deleteItem(item)
        });
    },

    deleteItem: function(item) {
        TELSA.loading(true);
        let route = (TELSA.apiHost + "commonobjects/itemsdelete");
        this.$http.post(route, {args: {itemId: item.item_id}}).then(response => {
            let result = response.body;
            this.getCommonObjectItems();
        });
    },

    newItem: function() {
        this.itemFields = [];
        let fields = this.$props.commonObject.object_fields;
        for(let field of fields) {
            this.itemFields.push({
                item_id: 0,
                item_value: '',
                object_field: field
            });
        }
        this.selectedItemClone = {item_name: ''};
        this.showItemEdit = true;
    },

    saveItems: function(itemName) {
        let route = (TELSA.apiHost + "commonobjects/itemsedit");
        if(this.itemFields[0].item_id == 0) {
            route = (TELSA.apiHost + "commonobjects/itemsadd");
        }
        TELSA.loading(true);
        return this.$http.post(route, {args: {objectId: this.$props.commonObject.object_id, itemName: itemName, items: this.itemFields}}).then(response => {
            let result = response.body;
            this.showItemEdit = false;
            this.getCommonObjectItems();
            TELSA.loading(false);
        });
    },

    onItemEditCancel: function() {
        if(this.$store.state.isDirty) {
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: 'Are you sure you want to abandon your changes without saving?',
                type: 'warning',
                confirmAction: () => {this.$store.commit('setIsDirty', false); this.showItemEdit = false;}
            });
        }
        else {
            this.showItemEdit = false;
        }
    },
  },

  watch: {
    
  },

  mounted() {
    this.getCommonObjectItems();
  }

  
};
</script>

<style scoped>
    .data-container {
        display: block;
        padding: 0;
    }

    #ag-grid-common-object-items-container {
        height: calc(100vh - 170px);
    }
</style>
